import { LAYOUT } from '/@/router/constant';
import type { AppRouteModule } from '/@/router/types';

// 会话管理路由
const sessionRoutes: AppRouteModule = {
  path: '/session',
  name: 'session',
  component: LAYOUT,
  meta: {
    orderNo: -90,
    icon: 'ant-design:profile-outlined',
    title: '会话管理',
  },
  children: [
    {
      path: 'settings',
      name: 'Settings',
      component: () => import('/@/views/sessionSettings/settings/Settings.vue'),
      meta: {
        // affix: true,
        title: '会话设置',
        icon: 'ant-design:form-outlined'
      },
    },
    {
      path: 'summary',
      name: 'summary',
      component: () => import('/@/views/sessionSettings/summary/Summary.vue'),
      meta: {
        title: '会话总结设置',
        icon: 'ant-design:fork-outlined'
      },
    },
    {
      path: 'historySession',
      name: 'HistorySession',
      component: () => import('/@/views/sessionInfo/historySession/HistorySession.vue'),
      meta: {
        // affix: true,
        title: '历史会话',
        icon: 'ant-design:clock-circle-outlined'
      },
    },
    {
      path: 'leaveWord',
      name: 'LeaveWord',
      component: () => import('/@/views/sessionInfo/leaveWord/LeaveWord.vue'),
      meta: {
        // affix: true,
        title: '留言列表',
        icon: 'ant-design:clock-circle-outlined'
      },
    },
    {
      path: 'sensitiveWord',
      name: 'SensitiveWord',
      component: () => import('/@/views/sessionSettings/sensitiveWord/SensitiveWord.vue'),
      meta: {
        title: '敏感词管理',
        icon: 'ant-design:issues-close-outlined'
      },
    },
    {
      path: 'blackAndWhiteList',
      name: 'BlackAndWhiteList',
      component: () => import('/@/views/sessionSettings/blackAndWhiteList/BlackAndWhiteList.vue'),
      meta: {
        title: '黑白名单管理',
        icon: 'ant-design:tag-outlined'
      },
    },
    {
      path: 'userPrivateAsset',
      name: 'UserPrivateAsset',
      component: () => import('/@/views/settings/userPrivateAsset/UserPrivateAsset.vue'),
      meta: {
        title: '私有图片列表',
        icon: 'ant-design:lock-outlined'
      },
    },
  ],
};

export default sessionRoutes;
